import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Engagement() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1E3A5F] to-[#2C5282]">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Engagement Models
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Flexible, cost-effective engagement models designed to meet your unique business needs while maintaining world-class quality and delivery standards
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-[#1E3A5F] mb-6">
              Optimized for Your Success
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              We are truly passionate about helping our customers succeed by providing world-class IT services through our unique engagement models while keeping costs optimal. Our ability to offer highly competitive pricing stems from keeping overheads to a bare minimum without compromising on quality or delivery excellence.
            </p>
          </div>
        </div>
      </section>

      {/* Engagement Models */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-[#1E3A5F] mb-16 text-center">
            Our Engagement Models
          </h2>

          {/* OOD Model */}
          <div className="mb-20">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="bg-gradient-to-r from-[#14B8A6] to-[#0D9488] p-8">
                <h3 className="text-3xl font-bold text-white mb-3">
                  Offshore Only Development (OOD)
                </h3>
                <p className="text-white/90 text-lg">
                  Most Cost-Effective Model - Highly Recommended
                </p>
              </div>
              <div className="p-8">
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  All development is performed by our offshore delivery centers in Hyderabad, India. Our onsite development lead will ensure consistent and constant customer engagement during US hours. In addition, our key resources in India development center are available until noon to provide sufficient coverage for important meetings every day and also available later in the day with advance notice.
                </p>
                
                <div className="grid md:grid-cols-3 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="w-12 h-12 bg-[#14B8A6] rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
                    </div>
                    <h4 className="font-bold text-[#1E3A5F] mb-2">No Onsite Cost</h4>
                    <p className="text-gray-600 text-sm">
                      Zero onsite expenses, maximizing your budget efficiency
                    </p>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="w-12 h-12 bg-[#14B8A6] rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-time-line text-2xl text-white"></i>
                    </div>
                    <h4 className="font-bold text-[#1E3A5F] mb-2">US Hours Coverage</h4>
                    <p className="text-gray-600 text-sm">
                      Onsite lead ensures constant engagement during business hours
                    </p>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="w-12 h-12 bg-[#14B8A6] rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-shield-check-line text-2xl text-white"></i>
                    </div>
                    <h4 className="font-bold text-[#1E3A5F] mb-2">SOW Accountability</h4>
                    <p className="text-gray-600 text-sm">
                      We are fully accountable for project delivery per SOW
                    </p>
                  </div>
                </div>

                <div className="bg-[#14B8A6]/10 border-l-4 border-[#14B8A6] p-6 rounded">
                  <p className="text-[#1E3A5F] font-semibold">
                    <i className="ri-star-fill text-[#14B8A6] mr-2"></i>
                    This is the most cost-effective model and we highly recommend this model for most projects.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* OOS Model */}
          <div className="mb-20">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="bg-gradient-to-r from-[#1E3A5F] to-[#2C5282] p-8">
                <h3 className="text-3xl font-bold text-white mb-3">
                  Offshore Only Support (OOS)
                </h3>
                <p className="text-white/90 text-lg">
                  24×7 or 16×5 Support Coverage
                </p>
              </div>
              <div className="p-8">
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  All hands-on support activities performed by our offshore delivery centers in Hyderabad, India. Our onsite support lead will ensure consistent and constant customer engagement during US hours. Our offshore resources will work in shifts for either 24×7 or 16×5 support.
                </p>
                
                <div className="grid md:grid-cols-3 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="w-12 h-12 bg-[#1E3A5F] rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-customer-service-2-line text-2xl text-white"></i>
                    </div>
                    <h4 className="font-bold text-[#1E3A5F] mb-2">Shift-Based Support</h4>
                    <p className="text-gray-600 text-sm">
                      24×7 or 16×5 coverage with dedicated shift teams
                    </p>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="w-12 h-12 bg-[#1E3A5F] rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
                    </div>
                    <h4 className="font-bold text-[#1E3A5F] mb-2">No Onsite Cost</h4>
                    <p className="text-gray-600 text-sm">
                      Cost-effective support without onsite expenses
                    </p>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="w-12 h-12 bg-[#1E3A5F] rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-settings-3-line text-2xl text-white"></i>
                    </div>
                    <h4 className="font-bold text-[#1E3A5F] mb-2">Customizable</h4>
                    <p className="text-gray-600 text-sm">
                      Open to adding onsite staff if customer desires
                    </p>
                  </div>
                </div>

                <div className="bg-[#1E3A5F]/10 border-l-4 border-[#1E3A5F] p-6 rounded">
                  <p className="text-[#1E3A5F] font-semibold">
                    <i className="ri-checkbox-circle-fill text-[#1E3A5F] mr-2"></i>
                    Based on our experience, this model works well for even large and complex support engagements.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 80-20 Model */}
          <div className="mb-20">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="bg-gradient-to-r from-[#0D9488] to-[#14B8A6] p-8">
                <h3 className="text-3xl font-bold text-white mb-3">
                  80-20 Model
                </h3>
                <p className="text-white/90 text-lg">
                  Hybrid Approach for Complex Projects
                </p>
              </div>
              <div className="p-8">
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  Certain complex projects do require key resources to be present onsite for detailed business and technical discussions on a regular basis, project management and executive engagement. In this model, 20% of our staff is present on the customer site and 80% of the staff will be located in our delivery centers in India.
                </p>
                
                <div className="grid md:grid-cols-2 gap-8 mb-8">
                  <div className="bg-gray-50 p-8 rounded-lg">
                    <div className="flex items-center mb-4">
                      <div className="w-16 h-16 bg-[#14B8A6] rounded-lg flex items-center justify-center mr-4">
                        <span className="text-3xl font-bold text-white">20%</span>
                      </div>
                      <h4 className="font-bold text-[#1E3A5F] text-xl">Onsite Team</h4>
                    </div>
                    <ul className="space-y-2 text-gray-600">
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#14B8A6] mr-2 mt-1"></i>
                        <span>Business & technical discussions</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#14B8A6] mr-2 mt-1"></i>
                        <span>Project management</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#14B8A6] mr-2 mt-1"></i>
                        <span>Executive engagement</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#14B8A6] mr-2 mt-1"></i>
                        <span>Regular customer interaction</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bg-gray-50 p-8 rounded-lg">
                    <div className="flex items-center mb-4">
                      <div className="w-16 h-16 bg-[#1E3A5F] rounded-lg flex items-center justify-center mr-4">
                        <span className="text-3xl font-bold text-white">80%</span>
                      </div>
                      <h4 className="font-bold text-[#1E3A5F] text-xl">Offshore Team</h4>
                    </div>
                    <ul className="space-y-2 text-gray-600">
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#1E3A5F] mr-2 mt-1"></i>
                        <span>Core development work</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#1E3A5F] mr-2 mt-1"></i>
                        <span>Testing & quality assurance</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#1E3A5F] mr-2 mt-1"></i>
                        <span>Technical implementation</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-[#1E3A5F] mr-2 mt-1"></i>
                        <span>Cost-effective delivery</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="bg-[#14B8A6]/10 border-l-4 border-[#14B8A6] p-6 rounded">
                  <p className="text-[#1E3A5F] font-semibold">
                    <i className="ri-lightbulb-line text-[#14B8A6] mr-2"></i>
                    Ideal for complex projects requiring regular onsite presence while maintaining cost efficiency.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Staff Augmentation */}
          <div>
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="bg-gradient-to-r from-[#2C5282] to-[#1E3A5F] p-8">
                <h3 className="text-3xl font-bold text-white mb-3">
                  Staff Augmentation
                </h3>
                <p className="text-white/90 text-lg">
                  Extend Your Team with Qualified Experts
                </p>
              </div>
              <div className="p-8">
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  We provide highly qualified and appropriately experienced resources in US and India in the following areas while customer retains responsibility for project or service delivery. Our resources will extend or augment the customer project team.
                </p>
                
                <div className="grid md:grid-cols-3 gap-4">
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-file-text-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">Content Management</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-search-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">Search and Commerce</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-git-merge-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">DevOps</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-cloud-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">Cloud Native & Migration</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-briefcase-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">Project & Program Management</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-seo-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">SEO</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-smartphone-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">Mobile & Web Development</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-global-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">Digital Operations</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-tools-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">Application & Operations Support</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-server-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">Infrastructure Support</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-stack-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">Middleware Technologies</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-bug-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">Manual & Automated QA</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-speed-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">Performance Engineering</span>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center">
                    <i className="ri-customer-service-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 font-medium">CRM Systems</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-[#1E3A5F] mb-12 text-center">
            Model Comparison
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full bg-white shadow-lg rounded-lg overflow-hidden">
              <thead className="bg-[#1E3A5F] text-white">
                <tr>
                  <th className="px-6 py-4 text-left font-semibold">Feature</th>
                  <th className="px-6 py-4 text-center font-semibold">OOD</th>
                  <th className="px-6 py-4 text-center font-semibold">OOS</th>
                  <th className="px-6 py-4 text-center font-semibold">80-20</th>
                  <th className="px-6 py-4 text-center font-semibold">Staff Aug.</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-700">Onsite Presence</td>
                  <td className="px-6 py-4 text-center">
                    <i className="ri-close-line text-red-500 text-xl"></i>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <i className="ri-close-line text-red-500 text-xl"></i>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className="text-[#14B8A6] font-semibold">20%</span>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <i className="ri-check-line text-[#14B8A6] text-xl"></i>
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-700">Cost Efficiency</td>
                  <td className="px-6 py-4 text-center">
                    <span className="text-[#14B8A6] font-semibold">Highest</span>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className="text-[#14B8A6] font-semibold">Highest</span>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className="text-gray-600">High</span>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className="text-gray-600">Variable</span>
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-700">Delivery Accountability</td>
                  <td className="px-6 py-4 text-center">
                    <i className="ri-check-line text-[#14B8A6] text-xl"></i>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <i className="ri-check-line text-[#14B8A6] text-xl"></i>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <i className="ri-check-line text-[#14B8A6] text-xl"></i>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className="text-gray-600 text-sm">Customer</span>
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-700">Best For</td>
                  <td className="px-6 py-4 text-center text-sm text-gray-600">Most Projects</td>
                  <td className="px-6 py-4 text-center text-sm text-gray-600">24×7 Support</td>
                  <td className="px-6 py-4 text-center text-sm text-gray-600">Complex Projects</td>
                  <td className="px-6 py-4 text-center text-sm text-gray-600">Team Extension</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-[#14B8A6] to-[#0D9488]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-white/90 mb-10 leading-relaxed">
            Let's discuss which engagement model best fits your project needs and budget. Our team is ready to help you succeed.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="bg-white text-[#14B8A6] px-10 py-4 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </a>
            <a
              href="/services"
              className="border-2 border-white text-white px-10 py-4 rounded-full font-semibold hover:bg-white hover:text-[#14B8A6] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View Services
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}